/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryResourceName extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryResourceName");
    }

    getFixupPrototypeFunction() { return ResourceQueryResourceName.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryResourceName>): ResourceQueryResourceName {
        let obj = Object.assign(new ResourceQueryResourceName(), model);
        ResourceQueryResourceName.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryResourceName>): ResourceQueryResourceName {
        if (!model) return null;
        return ResourceQueryResourceName.newInstance(<ResourceQueryResourceName> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryResourceName) {
        if (!obj) return;

        models.ResourceQueryResourceName.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryResourceName): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryResourceName.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Matches against the start of a resource name
     */
    starts_with: string;

}
